import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';

import { drawerInitialState } from './iconDrawerSlice';

const selectIconState = (state?: RootState) => state?.iconDrawer || drawerInitialState;

export const selectIconDrawer = createSelector([selectIconState], iconDrawer => iconDrawer);
